import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

// Import default images
import FooterShape1 from "../../../assets/images/shapes/footer-shape-1.png";
import footerLogo1 from "../../../assets/images/resources/logo-2.png";

const Footer = ({
  footerLogo = footerLogo1,
  footerShape = FooterShape1,
  footerClass = "site-footer",
  aboutText = "Your Vertical Partner for a Better Tomorrow.",
  contactInfo = [
    {
      icon: "icon-crane location-icon",
      text: "305, Silver Cross building, lokmanya college building, b/h HP Petrol pump, Shivranjani Cross Road, Satellite Road, Ahmedabad, Gujarat 380015",
      // link: "https://www.google.com/maps/place/ArchElevators+Pvt.+Ltd./@23.0358788,72.5174193,17z/data=!3m1!4b1!4m5!3m4!1s0x395e84c9a7d9b2f:0x6c8e7a9c8b1e5c8!8m2!3d23.0358788!4d72.519608",
    },

    {
      icon: "icon-location location-icon",
      text: " A 194, Road no 7, Gopal Charan Industrial Hub, Bakrol Bujrang, Gujarat 382433",
    },
    {
      icon: "icon-envolop email-icon",
      text: "info@archelevators.com",
      link: "mailto:info@archelevators.com",
    },
    
    {
      icon: "icon-call phone-call",
      text: "+91 90332 26011",
      link: "tel:+919033226011",
    },
  ],
  companyLinks = [
    { text: "About Us", link: "/about" },
    // { text: "FAQ", link: "/faq" },
    { text: "Testimonial", link: "/testimonials" },
    // { text: "Service", link: "/services" },
    // { text: "Blog And News", link: "/blog" },
  ],
  services = [
    { name: "Express Freight Solutions", link: "/express-freight-solutions" },
    { name: "Rapid Delivery Services", link: "/speedy-dispatch" },
    { name: "Speedy Haulage", link: "/speedy-haulage" },
    { name: "Reliable Transporters", link: "/reliable-transporters" },
    { name: "Swift Ship Solutions", link: "/swift-ship-solutions" },
  ],
  newsletterUrl = "MC_FORM_URL",
  newsletterText = "Financial planners help people to gain knowledge about",
  bottomMenu = [
    { text: "Terms & Conditions", link: "/terms-conditions" },
    { text: "Privacy Policy", link: "/privacy-policy" },
    { text: "Contact Us", link: "/contact" },
  ],
  copyrightText = "© archelevators.com 2025 | All Rights Reserved",
}) => {
  // Scroll to top button state
  const [showScroll, setShowScroll] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setShowScroll(window.scrollY > 200);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [location]);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  };

  return (
    <>
      {/*Site Footer Start*/}
      <footer className={footerClass}>
        <div className="site-footer__shape-1 float-bob-y">
          <img src={footerShape} alt="Footer Shape" />
        </div>
        <div className="site-footer__top">
          <div className="container">
            <div className="site-footer__top-inner">
              <div className="row">
                <div
                  className="col-xl-4 col-lg-6 col-md-6 wow fadeInUp"
                  data-wow-delay="100ms"
                >
                  <div className="footer-widget__column footer-widget__about">
                    <div className="footer-widget__logo">
                      <Link to="/">
                        <img src={footerLogo} alt="Logo" />
                      </Link>
                    </div>
                    <p className="footer-widget__about-text">{aboutText}</p>
                    <ul className="footer-widget__about-contact list-unstyled">
                      {contactInfo.map((info, index) => (
                        <li key={index}>
                          <div className="icon">
                            <span className={info.icon} />
                          </div>
                          <p>
                            {info.link ? (
                              <a href={info.link}>{info.text}</a>
                            ) : (
                              info.text
                            )}
                          </p>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                <div
                  className="col-xl-3 col-lg-6 col-md-6 wow fadeInUp"
                  data-wow-delay="200ms"
                >
                  <div className="footer-widget__column footer-widget__company">
                    <div className="footer-widget__title-box">
                      <h3 className="footer-widget__title">About Company</h3>
                    </div>
                    <ul className="footer-widget__company-list list-unstyled">
                      {companyLinks.map((link, index) => (
                        <li key={index}>
                          <Link to={link.link}>{link.text}</Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                {/* <div
                  className="col-xl-3 col-lg-6 col-md-6 wow fadeInUp"
                  data-wow-delay="300ms"
                >
                  <div className="footer-widget__column footer-widget__services">
                    <div className="footer-widget__title-box">
                      <h3 className="footer-widget__title">Services</h3>
                    </div>
                    <ul className="footer-widget__services-list list-unstyled">
                      {services.map((service, index) => (
                        <li key={index}>
                          <Link to={service.link}>
                            <span className="icon-angle-left" />
                            {service.name}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div> */}
                <div
                  className="col-xl-4 col-lg-6 col-md-6 wow fadeInUp"
                  data-wow-delay="400ms"
                >
                  <div className="footer-widget__column footer-widget__newsletter">
                    <div className="footer-widget__title-box">
                      <h3 className="footer-widget__title">Newsletter</h3>
                    </div>
                    <p className="footer-widget__newsletter-text">
                      {newsletterText}
                    </p>
                    <form
                      className="footer-widget__newsletter-form mc-form"
                      data-url={newsletterUrl}
                      noValidate="novalidate"
                    >
                      <div className="footer-widget__newsletter-form-input-box">
                        <input
                          type="email"
                          placeholder="Your e-mail"
                          name="EMAIL"
                        />
                        <button
                          type="submit"
                          className="footer-widget__newsletter-btn"
                        >
                          <span className="icon-paper-plane" />
                        </button>
                      </div>
                    </form>
                    <div className="mc-form__response" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="site-footer__bottom">
          <div className="container">
            <div className="site-footer__bottom-inner">
              <p className="site-footer__bottom-text">{copyrightText}</p>
              <ul className="list-unstyled site-footer__bottom-menu">
                {bottomMenu.map((item, index) => (
                  <li key={index}>
                    <Link to={item.link}>{item.text}</Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </footer>
      {/*Site Footer End*/}
      {showScroll && (
        <button
          className="scroll-to-top"
          style={{
            position: "fixed",
            right: 24,
            bottom: 32,
            zIndex: 9999,
            background: "#222",
            color: "#fff",
            border: "none",
            borderRadius: "50%",
            width: 48,
            height: 48,
            boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
            cursor: "pointer",
            fontSize: 24,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transition: "opacity 0.3s"
          }}
          aria-label="Scroll to top"
          onClick={scrollToTop}
        >
          ↑
        </button>
      )}
    </>
  );
};

export default Footer;
